import gql from 'graphql-tag';
import xaxios from '@/xaxios';

export default class CobranzasService {
  getInscripciones(vue, programaid, callback) {
    var sql = gql`query{ getPrograma(id:${programaid}){id,nombre_compuesto,plataforma_id,inscripciones{id,estado_ins,fecha_registro,estudiante{id,num_doc,telefono1,usuario_moodle,nombres,pri_apellido,seg_apellido,estado,fecha_nac}}}}`;
    vue.$apollo.query({ query: sql }).then(({ data }) => callback(data.getPrograma));
  }

  async getPlanKardex(idinscripcion) {
    const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
    const res = await xaxios
      .get(url)
      .then(({ data }) => data)
      .catch(() => []);
    return res;
  }

  async getOnlyPlataformas(vue) {
    var sql = gql`
      query {
        getPlataformas {
          id
          direccion
        }
      }
    `;
    const res = await vue.$apollo.query({ query: sql }).then(({ data }) => data.getPlataformas);
    return res;
  }

  async cambiarEstadoInModulosMoodle(idprograma, personas, xplataforma, newestado = 0) {
    const url = `${process.env.VUE_APP_API_REST}/esam/programa/id/${idprograma}`;
    const promise1 = xaxios.get(url);
    const promesas = [];
    const bloquear = [];
    const values = await Promise.all([promise1]).then((values) => values);
    const modulos = values[0];

    if (!modulos.data.programa_modulo) modulos.data.programa_modulo = [];
    modulos.data.programa_modulo.sort((a, b) => a.course_id - b.course_id);
    modulos.data.programa_modulo.forEach(async (e) => {
      if (e.course_id) {
        const urlx = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          xplataforma.id
        }/course/id/${e.course_id}/enrolment/gradeitem/grade`;
        promesas.push(xaxios.get(urlx));
      }
    });
    const values2 = await Promise.allSettled(promesas).then((values) => values);
    values2.forEach((x) => {
      let value = x.value;
      if (value) value = value.data;
      if (value) {
        window.console.log(value, personas);
        personas.forEach((per) => {
          const enrol = value.enrolments.find((enrol) => enrol.user.username == per.usuario_moodle);
          if (enrol) {
            this.soloUltimoModulo(bloquear, enrol, newestado);
          }
        });
      }
    });
    // window.console.log(bloquear);
    const datas = [];
    bloquear.forEach((b) => {
      const data = {
        username: b.user.username,
        course_id: b.course_id,
        current_status: newestado,
        desired_status: newestado == 0 ? 1 : 0,
      };
      datas.push(data);
    });
    window.console.log(datas);
    const promesasmoodle = [];
    const urlmoodle = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
      xplataforma.id
    }/enrolment/status`;
    datas.forEach((d) => {
      promesasmoodle.push(xaxios.post(urlmoodle, d));
    });
    const resultado = await Promise.allSettled(promesasmoodle).then((val) => val);
    const respuesta = [];
    window.console.log(promesasmoodle);
    window.console.log(resultado);
    resultado.forEach((r) => {
      const re = {};
      if (r.status == 'rejected') {
        const jotason = JSON.parse(r.reason.config.data);
        re.username = jotason.username;
        re.result = `No se pudo cambiar, posiblemente ya estaba suspendido en ID MOODLE: ${jotason.course_id}`;
      } else {
        const jotason = JSON.parse(r.value.config.data);
        re.username = jotason.username;
        re.result = `Suspendido del modulo con ID MOODLE: ${jotason.course_id}`;
      }
      respuesta.push(re);
    });
    return respuesta;
  }

  soloUltimoModulo(bloquear, enrol, newestado) {
    const existe = bloquear.find((b) => b.user.username == enrol.user.username);
    window.console.log(enrol.user.username, enrol.course_id, newestado);
    if (existe) {
      if (existe.course_id < enrol.course_id) {
        existe.course_id = enrol.course_id;
      }
    } else {
      bloquear.push(enrol);
    }
  }
}
